{
  "title": "Cài đặt",
  "subtitle": "Cấu hình tổ chức và tài khoản của bạn",
  "back": "Cài đặt",
  "save": "Lưu thay đổi",
  "saved": "Đã lưu thay đổi",
  "savedApplied": "Đã lưu và áp dụng cho {{count}} đăng ký",
  "groups": {
    "org": "Tổ chức",
    "account": "Tài khoản"
  },
  "sections": {
    "organization": {
      "title": "Thông tin tổ chức",
      "desc": "Tên, logo và màu thương hiệu hiện trên phiếu học phí và sổ liên lạc phụ huynh mở."
    },
    "members": {
      "title": "Thành viên & quyền",
      "desc": "Ai được vào lớp của bạn và làm được gì (kèm mức lương giáo viên)."
    },
    "branches": {
      "title": "Chi nhánh",
      "desc": "Các cơ sở của bạn. Lọc lớp, điểm danh và lương theo từng nơi."
    },
    "bank": {
      "title": "Ngân hàng",
      "desc": "Tài khoản nhận học phí và đối soát tự động."
    },
    "billing": {
      "title": "Gói & thanh toán",
      "desc": "Gói đang dùng và hoá đơn của LopHoc."
    },
    "billing-rules": {
      "title": "Quy tắc học phí",
      "desc": "Những cài đặt làm thay đổi số tiền trên hoá đơn."
    },
    "display": {
      "title": "Hiển thị",
      "desc": "Cách LopHoc hiện thông tin, không ảnh hưởng học phí."
    },
    "audit": {
      "title": "Nhật ký thao tác",
      "desc": "Ai đã làm gì trong lớp, ghi lại theo thời gian. Chỉ chủ lớp và quản trị viên xem được."
    },
    "profile": {
      "title": "Hồ sơ cá nhân",
      "desc": "Tên và email đăng nhập của bạn."
    },
    "password": {
      "title": "Mật khẩu",
      "desc": "Đổi mật khẩu đăng nhập."
    }
  },
  "billingRules": {
    "alert": "Cài đặt ở đây thay đổi số tiền trên hoá đơn sinh từ chốt sổ. Thay đổi áp dụng cho mọi kỳ chưa chốt, kỳ đã chốt không đổi."
  },
  "profile": {
    "title": "Tài khoản",
    "fullName": "Họ và tên",
    "email": "Email",
    "role": "Vai trò",
    "password": "Mật khẩu",
    "edit": "Sửa",
    "cancel": "Huỷ",
    "emailVerified": "Đã xác nhận",
    "emailNotVerified": "Chưa xác nhận",
    "resendVerify": "Gửi lại email xác nhận",
    "sending": "Đang gửi...",
    "emailSent": "Đã gửi!",
    "resendError": "Lỗi, thử lại",
    "save": "Lưu",
    "saving": "Đang lưu...",
    "nameUpdated": "Đã cập nhật họ tên",
    "security": {
      "open": "Đổi",
      "currentPassword": "Mật khẩu hiện tại",
      "newPassword": "Mật khẩu mới",
      "confirmPassword": "Xác nhận mật khẩu mới",
      "submit": "Đổi mật khẩu",
      "submitting": "Đang đổi...",
      "changed": "Đã đổi mật khẩu",
      "hint": "Mật khẩu mới cần ít nhất 8 ký tự.",
      "errCurrentRequired": "Vui lòng nhập mật khẩu hiện tại",
      "errTooShort": "Mật khẩu mới cần ít nhất 8 ký tự",
      "errMismatch": "Mật khẩu xác nhận không khớp",
      "errSameAsCurrent": "Mật khẩu mới phải khác mật khẩu hiện tại",
      "errWrongCurrent": "Mật khẩu hiện tại không đúng"
    },
    "org": {
      "title": "Tổ chức",
      "name": "Tên tổ chức",
      "logo": "Logo",
      "changeLogo": "Đổi logo",
      "noLogo": "Chưa có logo",
      "logoHint": "Logo hiển thị trên phiếu học phí và sổ liên lạc gửi cho phụ huynh, và là icon của app khi phụ huynh cài sổ ra màn hình.",
      "updated": "Đã cập nhật tổ chức",
      "readOnly": "Chỉ chủ tổ chức hoặc quản trị viên mới sửa được thông tin này.",
      "brandColor": "Màu thương hiệu",
      "brandColorHint": "Dùng cho sổ liên lạc, phiếu học phí gửi phụ huynh và app cài ra màn hình điện thoại. Màu điểm danh không đổi.",
      "brandColorLocked": "Màu thương hiệu có từ gói Pro",
      "brandColorSave": "Lưu",
      "brandColorReset": "Về mặc định",
      "brandColorCustom": "Màu khác"
    },
    "crop": {
      "title": "Cắt logo",
      "description": "Kéo ảnh để chọn vùng, dùng thanh trượt để thu phóng. Logo được cắt vuông.",
      "zoom": "Thu phóng",
      "choose": "Chọn ảnh",
      "confirm": "Dùng ảnh này",
      "cancel": "Huỷ",
      "uploading": "Đang tải lên...",
      "errType": "Chỉ nhận ảnh PNG, JPG hoặc WEBP",
      "errSize": "Ảnh phải nhỏ hơn 2 MB",
      "errUpload": "Tải ảnh lên thất bại, vui lòng thử lại"
    }
  },
  "team": {
    "title": "Thành viên",
    "memberCount": "{{count}} thành viên trong tổ chức",
    "seatCount": "{{used}} / {{max}} suất giáo viên",
    "invite": "Mời thành viên",
    "empty": "Chưa có thành viên nào",
    "you": "(bạn)",
    "pendingTitle": "Lời mời đang chờ",
    "pendingEmpty": "Không có lời mời nào đang chờ",
    "expires": "Hết hạn {{date}}",
    "inviteTitle": "Mời thành viên",
    "inviteDescription": "Gửi email mời tham gia tổ chức. Lời mời có hiệu lực 7 ngày.",
    "inviteEmail": "Email",
    "inviteEmailPlaceholder": "colleague@example.com",
    "inviteRole": "Vai trò",
    "inviteCancel": "Huỷ",
    "inviteSubmit": "Gửi lời mời",
    "inviteSubmitting": "Đang gửi...",
    "toastInvited": "Đã gửi lời mời",
    "toastReactivated": "Đã kích hoạt lại thành viên.",
    "toastAlreadyMember": "Người này đã là thành viên",
    "toastInviteError": "Không thể gửi lời mời",
    "toastRoleUpdated": "Đã cập nhật vai trò",
    "toastRoleError": "Không thể cập nhật vai trò",
    "toastRemoved": "Đã xoá {{name}}: lưu trữ {{archivedSlots}} lớp, gỡ {{removedSessions}} buổi",
    "toastRemoveError": "Không thể xoá thành viên",
    "removePreviewError": "Không thể tải thông tin xoá giáo viên",
    "removeConfirmTitle": "Xoá {{name}}?",
    "removeConfirmDescription": "GV này còn {{activeSlots}} lớp cố định + {{futureSessions}} buổi sắp tới, các lớp sẽ được lưu trữ và các buổi chưa dạy sẽ bị gỡ. Buổi đã dạy và điểm danh vẫn được giữ.",
    "removeConfirmAction": "Xoá giáo viên",
    "revoke": "Thu hồi",
    "revokeConfirmTitle": "Thu hồi lời mời?",
    "revokeConfirmDescription": "Lời mời gửi tới {{email}} sẽ bị huỷ và suất giáo viên sẽ được giải phóng ngay.",
    "revokeConfirmAction": "Thu hồi lời mời",
    "toastInvitationRevoked": "Đã thu hồi lời mời",
    "toastInvitationAlreadyAccepted": "Lời mời đã được chấp nhận, không thể thu hồi",
    "toastInvitationRevokeError": "Không thể thu hồi lời mời",
    "addTeacher": "Thêm giáo viên",
    "addTeacherEmailMode": "Mời qua email",
    "addTeacherQuickMode": "Thêm nhanh (không cần tài khoản)",
    "noAccountBadge": "Chưa có tài khoản",
    "convertAction": "Chuyển thành tài khoản",
    "quickAddTitle": "Thêm nhanh giáo viên",
    "quickAddDescription": "Thêm giáo viên chỉ bằng tên, không cần email hay tài khoản. Bạn có thể chuyển thành tài khoản thật sau.",
    "quickAddName": "Tên giáo viên",
    "quickAddNamePlaceholder": "VD: Cô Lan",
    "quickAddSubmit": "Thêm giáo viên",
    "toastPlaceholderAdded": "Đã thêm giáo viên",
    "toastPlaceholderError": "Không thể thêm giáo viên",
    "convertTitle": "Chuyển thành tài khoản",
    "convertDescription": "Nhập email để giáo viên nhận link đặt mật khẩu và đăng nhập được.",
    "convertEmail": "Email",
    "convertSubmit": "Gửi link đặt mật khẩu",
    "toastConverted": "Đã gửi link đặt mật khẩu",
    "toastConvertError": "Không thể chuyển thành tài khoản",
    "toastConvertEmailExists": "Email này đã được dùng bởi tài khoản khác"
  },
  "bank": {
    "title": "Ngân hàng",
    "description": "Liên kết tài khoản ngân hàng để nhận thanh toán từ hoá đơn qua VietQR",
    "connected": "Đã kết nối",
    "unlink": "Huỷ",
    "emptyTitle": "Chưa có tài khoản ngân hàng nào",
    "emptyDescription": "Liên kết ngân hàng để tự động nhận thông báo khi khách thanh toán",
    "linkButton": "Liên kết tài khoản ngân hàng",
    "linking": "Đang kết nối...",
    "linkError": "Không thể liên kết tài khoản ngân hàng",
    "unlinkError": "Không thể huỷ liên kết tài khoản ngân hàng",
    "reconcile": {
      "activeLabel": "Tự động đối soát: Đang bật",
      "offLabel": "Tự động đối soát: Đã tắt",
      "pausedLabel": "Tự động đối soát: Tạm dừng (hết lượt tháng này)",
      "usage": "Đã dùng {{used}}/{{quota}} giao dịch tháng này",
      "unlimited": "Không giới hạn",
      "offSubtext": "Nâng cấp để tự động ghi nhận thanh toán",
      "offCta": "Nâng cấp",
      "pausedSubtext": "Sẽ tự bật lại đầu tháng sau, hoặc nâng cấp gói."
    },
    "primary": "Nhận học phí",
    "usePrimary": "Dùng tài khoản này",
    "primaryHint": "Mã QR trên mọi phiếu học phí in tài khoản có nhãn Nhận học phí. Tài khoản còn lại vẫn liên kết: phụ huynh chuyển vào đó đúng nội dung vẫn tự khớp, sai nội dung thì vào Giao dịch chưa khớp như thường.",
    "primaryConfirmTitle": "Đổi tài khoản nhận học phí?",
    "primaryConfirmBody": "Mã QR trên mọi phiếu học phí sẽ đổi sang {{bank}} {{account}} từ lần mở tiếp theo. Tài khoản cũ vẫn liên kết và vẫn được đối soát như trước.",
    "primaryConfirm": "Đổi",
    "primaryCancel": "Giữ như cũ",
    "primarySaved": "Đã đổi tài khoản nhận học phí",
    "primaryError": "Không đổi được tài khoản nhận học phí"
  },
  "branches": {
    "title": "Chi nhánh",
    "description": "Mỗi lớp thuộc một chi nhánh. Bạn lọc thời khoá biểu, điểm danh và lương theo chi nhánh, tiền vẫn gộp chung một sổ.",
    "add": "Thêm chi nhánh",
    "addTitle": "Thêm chi nhánh",
    "nameLabel": "Tên chi nhánh",
    "namePlaceholder": "Cơ sở Lê Lợi",
    "empty": "Chưa có chi nhánh nào",
    "emptyDescription": "Thêm cơ sở đầu tiên để lọc lớp theo nơi dạy.",
    "slotCount": "{{count}} lớp",
    "archivedBadge": "Đã lưu trữ",
    "showArchived": "Hiện chi nhánh đã lưu trữ",
    "hideArchived": "Ẩn chi nhánh đã lưu trữ",
    "rename": "Đổi tên",
    "renameTitle": "Đổi tên chi nhánh",
    "archive": "Lưu trữ",
    "archiveTitle": "Lưu trữ chi nhánh này?",
    "archiveBody": "Chi nhánh sẽ biến mất khỏi bộ lọc và form lớp. Lớp cũ vẫn giữ nguyên tên chi nhánh.",
    "unarchive": "Khôi phục",
    "created": "Đã thêm chi nhánh",
    "renamed": "Đã đổi tên chi nhánh",
    "archivedToast": "Đã lưu trữ chi nhánh",
    "unarchivedToast": "Đã khôi phục chi nhánh",
    "error": "Không thể lưu chi nhánh",
    "upsellTitle": "Tính năng của gói Center",
    "upsellBody": "Chi nhánh của bạn vẫn được giữ nguyên, nâng lên Center để bật lại lọc theo cơ sở, thêm chi nhánh mới và khôi phục chi nhánh đã lưu trữ.",
    "upsellCta": "Xem gói Center",
    "addFirstTitle": "Chi nhánh đầu tiên",
    "addFirstDesc": "Đặt tên cơ sở bạn đang dạy. Sau này thêm cơ sở mới thì lớp mới gán vào đó.",
    "create": "Tạo chi nhánh",
    "assignAllLabel": "Gán tất cả {{count}} lớp hiện có vào chi nhánh này",
    "assignAllHelp": "Toàn bộ lớp, thời khoá biểu và điểm danh đã có sẽ thuộc cơ sở này. Không có gì bị xoá hay đổi số, và bạn chuyển từng lớp sang cơ sở khác sau, bất cứ lúc nào.",
    "assignAllOffWarning": "{{count}} lớp này sẽ chưa thuộc chi nhánh nào, nên khi bạn lọc theo một cơ sở thì chúng không hiện ra. Gán lại sau ở Cài đặt · Chi nhánh.",
    "unassignedWarning": "{{count}} lớp chưa thuộc chi nhánh. Chúng không hiện khi bạn lọc theo cơ sở.",
    "bulkAssign": "Gán hàng loạt",
    "bulkAssignTitle": "Gán lớp chưa có chi nhánh",
    "bulkAssignDesc": "Chọn cơ sở sẽ nhận {{count}} lớp này. Bạn chuyển từng lớp sang cơ sở khác sau, bất cứ lúc nào.",
    "bulkAssignTarget": "Chi nhánh nhận",
    "bulkAssignDone": "Đã gán {{count}} lớp"
  },
  "preferences": {
    "industry": "Lĩnh vực",
    "teamSize": "Quy mô",
    "preferredChannel": "Kênh liên lạc",
    "defaultCurrency": "Đơn vị tiền tệ",
    "saving": "Đang lưu...",
    "toastUpdated": "Đã cập nhật tuỳ chọn",
    "toastError": "Không thể cập nhật",
    "language": "Ngôn ngữ",
    "langVi": "Tiếng Việt",
    "langEn": "English",
    "IT_WEB": "IT / Web",
    "DESIGN": "Thiết kế",
    "CONTENT": "Nội dung",
    "CONSULTING": "Tư vấn",
    "OTHER": "Khác",
    "SOLO": "Dạy một mình",
    "SMALL": "Có trợ giảng",
    "MEDIUM": "Trung tâm nhỏ",
    "ZALO": "Zalo",
    "EMAIL": "Email",
    "BOTH_channel": "Cả hai",
    "VND": "VND",
    "USD": "USD",
    "BOTH_currency": "Cả hai",
    "businessType": "Hình thức kinh doanh",
    "businessTypeUnregistered": "Chưa đăng ký kinh doanh",
    "businessTypeHousehold": "Hộ kinh doanh",
    "businessTypeEnterprise": "Doanh nghiệp (công ty)",
    "showTeacherAssignment": "Phân công giáo viên",
    "showTeacherAssignmentDesc": "Hiện lựa chọn giáo viên cho lớp/buổi (bật khi có nhiều giáo viên)",
    "classMode": "Tổ chức lớp",
    "classModeCohort": "Lớp học chung",
    "classModeIndividual": "Học riêng từng em",
    "classModeHelper": "Đặt mặc định cho nút Tạo lớp, form lớp, màu trên lịch và cột Lớp ở Học viên. Không đổi cách tính tiền.",
    "sellsExtras": "Bán thêm sản phẩm/dịch vụ",
    "sellsExtrasDesc": "Hiện luồng tạo hoá đơn bán thêm ngoài khóa học",
    "sellsExtrasLocked": "Bán phụ chỉ có ở gói Pro. Nâng cấp để bật.",
    "businessTypeHelper": "Lựa chọn này quyết định loại sổ/báo cáo bạn có thể xuất ở mục Sổ thu chi.",
    "chargeAbsentTitle": "Tính tiền buổi vắng không phép",
    "chargeAbsentDescription": "Giá trị mặc định khi tạo đăng ký học mới. Đổi ở đây không thay đổi các đăng ký đang chạy.",
    "chargeAbsentApplyAll": "Áp dụng cho tất cả đăng ký hiện có",
    "chargeAbsentApplyConfirmTitle": "Lưu mặc định và áp dụng cho tất cả đăng ký?",
    "chargeAbsentApplyConfirmBody1": "Thao tác này sẽ lưu lại giá trị mặc định ở trên, đồng thời đổi",
    "chargeAbsentApplyConfirmBody2": "đăng ký tính theo tháng và",
    "chargeAbsentApplyConfirmBody3": "đăng ký theo khoá. Áp dụng cho mọi thứ chưa xuất hoá đơn, kể cả tháng chưa chốt. Với đăng ký theo khoá, toàn bộ khoá đang chạy sẽ được đếm lại.",
    "chargeAbsentApplyCancel": "Huỷ",
    "chargeAbsentApplyConfirm": "Lưu và áp dụng",
    "chargeAbsentApplyDone": "Đã lưu mặc định và cập nhật {{count}} đăng ký",
    "maxExcusedTitle": "Số buổi phép tối đa mỗi tháng",
    "maxExcusedHint": "Quá số này, nút Có phép chuyển đỏ khi điểm danh. Để trống nếu không giới hạn.",
    "watermarkTitle": "Watermark hóa đơn",
    "watermarkDescription": "Hiển thị dòng \"Tạo bởi LopHoc.app\" trên hóa đơn công khai, cách miễn phí để ủng hộ LopHoc.app lan tỏa.",
    "watermarkForcedNote": "Gói Free luôn hiển thị watermark.",
    "templateTitle": "Mẫu tin nhắn gửi hóa đơn",
    "templateDescription": "Tin nhắn phụ huynh nhận được khi bạn gửi hóa đơn thủ công (tab Gửi tay).",
    "templateTokenPayer": "Phụ huynh",
    "templateTokenPeriod": "Kỳ",
    "templateTokenStudents": "Học viên",
    "templateTokenTotal": "Tổng tiền",
    "templateTokenLink": "Link hóa đơn",
    "templateTokenDueDate": "Hạn thanh toán",
    "templateCharCount": "{{count}}/2000 ký tự",
    "templatePreviewTitle": "Xem trước",
    "templateRestoreDefault": "Khôi phục mẫu mặc định",
    "templateHelper": "Các nút bên trên chỉ để chèn nhanh, không bắt buộc. Xưng hô (\"Thầy\"/\"Cô\") là văn bản thường, sửa trực tiếp trong mẫu. Xóa trống và lưu sẽ quay về mẫu mặc định.",
    "invoiceDueDayTitle": "Ngày hạn thanh toán mặc định",
    "invoiceDueDayHint": "Áp dụng khi chốt sổ tháng. Để trống thì hạn là 7 ngày sau khi tạo hoá đơn. Có thể lưu nhanh từ hộp thoại chốt sổ."
  },
  "audit": {
    "filters": {
      "group": "Nhóm thao tác",
      "actor": "Người thực hiện",
      "from": "Từ ngày",
      "to": "Đến ngày",
      "toSep": "đến",
      "clear": "Xoá lọc"
    },
    "groups": {
      "all": "Mọi thao tác",
      "money": "Tiền",
      "students": "Học viên và ghi danh",
      "clients": "Hoá đơn và khách hàng",
      "org": "Tổ chức",
      "other": "Khác"
    },
    "actor": {
      "all": "Mọi người",
      "platform": "LopHoc",
      "system": "Hệ thống",
      "unknownMember": "Thành viên"
    },
    "link": {
      "invoice": "Xem hoá đơn",
      "student": "Xem học viên",
      "client": "Xem khách hàng",
      "subject": "Xem môn học"
    },
    "count": "{{count}} thao tác",
    "empty": "Chưa có thao tác nào được ghi.",
    "emptyFiltered": "Không có thao tác nào khớp bộ lọc.",
    "loading": "Đang tải...",
    "error": "Không tải được nhật ký. Thử lại sau.",
    "pager": {
      "summary": "Trang {{page}} / {{pages}}",
      "prev": "Trước",
      "next": "Sau"
    },
    "summary": {
      "bulk": "xoá hàng loạt",
      "monthReopened": "Tháng {{month}}/{{year}}, thu hồi {{count}} hoá đơn nháp",
      "modeSession": "Theo buổi",
      "modeTerm": "Theo khoá",
      "modeFlat": "Tháng cố định",
      "fromTo": "{{from}} thành {{to}}",
      "chargeAbsentOn": "Bật tính tiền buổi vắng không phép",
      "chargeAbsentOff": "Tắt tính tiền buổi vắng không phép",
      "chargeAbsentBulk": "{{state}} cho {{count}} đăng ký",
      "on": "Bật",
      "off": "Tắt",
      "tagsAdded": "Thêm: {{tags}}",
      "tagsRemoved": "Bỏ: {{tags}}",
      "payerPending": "{{count}} hoá đơn chưa trả giữ người thanh toán cũ",
      "template": "Mẫu {{name}}: {{joined}} vào lớp, {{left}} rời lớp",
      "progressLinks": "Tạo {{created}} link, {{existing}} link đã có",
      "monthClosed": "Tháng {{month}}/{{year}}, {{count}} hoá đơn, tổng {{total}}",
      "channelZalo": "qua Zalo",
      "channelEmail": "qua email",
      "tag": "Thẻ: {{tag}}",
      "fieldFromTo": "{{field}}: {{from}} thành {{to}}",
      "memberInvited": "{{email}} với vai trò {{role}}",
      "memberRemoved": "{{name}}, lưu trữ {{slots}} lớp, gỡ {{sessions}} buổi chưa dạy",
      "bank": "{{bank}} ****{{last4}}",
      "branchSlots": "{{count}} lớp vào {{name}}",
      "upgrade": "Gói {{plan}}, {{cycle}}, {{amount}}",
      "cycleMonthly": "theo tháng",
      "cycleAnnual": "theo năm",
      "invoiceUpdated": "{{code}}, đổi {{fields}}",
      "invoiceUpdatedItems": "{{code}}, thêm {{count}} dòng",
      "paymentFor": "{{amount}} cho {{code}}",
      "sourceCash": "tiền mặt",
      "sourceBank": "chuyển khoản ngoài",
      "sourceSepay": "tự khớp",
      "dueDateBulk": "{{count}} hoá đơn, hạn {{date}}",
      "payrollAdjust": "{{amount}}, tháng {{month}}",
      "unlinked": "chưa gán",
      "empty": "trống",
      "imported": "{{created}} học viên, bỏ qua {{skipped}} dòng",
      "withCount": "{{name}} · {{count}} {{unit}}",
      "unitStudents": "học viên",
      "unitEnrollments": "đăng ký",
      "unitEntries": "mục",
      "slot": "{{subject}} · {{day}} {{time}}",
      "slotMembers": "{{subject}} · {{day}} {{time}} · {{count}} học viên",
      "classCreated": "Tạo lớp {{displayName}} ({{slotCount}} khung giờ)",
      "classUpdated": "Đổi {{field}} của lớp",
      "classArchived": "Lưu trữ lớp ({{slotCount}} khung giờ)",
      "classUnarchived": "Khôi phục lớp ({{slotCount}} khung giờ)",
      "classCascaded": "tự động theo khung giờ",
      "classMembersAdded": "Thêm {{n}} học viên vào lớp {{displayName}}",
      "session": "{{subject}} · {{when}}",
      "sessionParticipants": "{{subject}} · {{when}} · {{count}} học viên",
      "movedTo": "{{name}} sang buổi {{when}}",
      "day1": "CN",
      "day2": "T2",
      "day3": "T3",
      "day4": "T4",
      "day5": "T5",
      "day6": "T6",
      "day7": "T7",
      "bankSwitch": "{{fromBank}} ****{{fromLast4}} sang {{bank}} ****{{last4}}"
    },
    "actions": {
      "INVOICE_DELETED": "Xoá hoá đơn",
      "INVOICE_CLIENT_CHANGED": "Đổi người thanh toán trên hoá đơn",
      "MONTH_REOPENED": "Mở lại tháng đã chốt",
      "PAYROLL_FINALIZED": "Chốt lương giáo viên",
      "PAYROLL_REOPENED": "Mở lại bảng lương",
      "PAYER_REASSIGNED": "Đổi người thanh toán của học viên",
      "PROMOTION_APPLIED": "Áp dụng ưu đãi cho gói",
      "SEPAY_COMPANY_REMAPPED": "Đổi kết nối ngân hàng",
      "SEPAY_COMPANY_STATUS_CHANGED": "Đổi trạng thái kết nối ngân hàng",
      "SEPAY_DEPOSIT_ADJUSTED": "Điều chỉnh ký quỹ đối soát",
      "SEPAY_LINK_TOKEN_REVOKED": "Thu hồi link liên kết ngân hàng",
      "SEPAY_UNLINK_STARTED": "Bắt đầu gỡ liên kết ngân hàng",
      "ENROLLMENT_CREATED": "Tạo đăng ký học",
      "ENROLLMENT_PAUSED": "Tạm dừng đăng ký",
      "ENROLLMENT_RESUMED": "Học lại",
      "ENROLLMENT_ENDED": "Kết thúc đăng ký",
      "ENROLLMENT_RATE_CHANGED": "Đổi học phí",
      "ENROLLMENT_DELETED": "Xoá đăng ký",
      "ENROLLMENT_CHARGE_ABSENT_CHANGED": "Đổi luật tính buổi vắng",
      "ENROLLMENT_CHARGE_ABSENT_BULK": "Đổi luật tính buổi vắng hàng loạt",
      "STUDENT_TAGS_CHANGED": "Cập nhật thẻ phân loại",
      "STUDENT_DEACTIVATED": "Ngừng học viên",
      "STUDENT_REACTIVATED": "Kích hoạt lại học viên",
      "STUDENT_DELETED": "Xoá học viên",
      "STUDENT_PROGRESS_LINK_BULK_CREATED": "Tạo link sổ liên lạc hàng loạt",
      "SLOT_MEMBER_MOVED": "Chuyển lớp cho học viên",
      "SCHEDULE_TEMPLATE_APPLIED": "Áp dụng mẫu lịch học",
      "INVITATION_REVOKED": "Thu hồi lời mời thành viên",
      "PLAN_ASSIGNED": "Gán gói dịch vụ",
      "ORG_SUSPENDED": "Tạm khoá tổ chức",
      "ORG_UNSUSPENDED": "Mở khoá tổ chức",
      "DEMO_ORG_RESET": "Dàn lại dữ liệu mẫu",
      "STUDENT_PROGRESS_LINK_CREATED": "Tạo link sổ liên lạc",
      "STUDENT_PROGRESS_LINK_ROTATED": "Đổi link sổ liên lạc",
      "SUBJECT_NOTE_TEMPLATE_UPDATED": "Cập nhật sườn nhận xét",
      "SUBJECT_NOTE_TEMPLATE_REMOVED": "Xoá sườn nhận xét",
      "MONTH_CLOSED": "Chốt sổ tháng",
      "CLIENT_INVOICE_CREATED": "Tạo hoá đơn cho khách hàng",
      "CLIENT_INVOICE_SENT": "Gửi hoá đơn cho khách hàng",
      "CLIENT_INVOICE_PAID": "Khách hàng đã thanh toán",
      "CLIENT_INVOICE_OVERDUE": "Hoá đơn quá hạn",
      "CLIENT_INVOICE_CANCELLED": "Huỷ hoá đơn",
      "CLIENT_INVOICE_VIEWED": "Khách hàng đã xem hoá đơn",
      "CLIENT_REMINDER_SENT": "Gửi nhắc thanh toán",
      "CLIENT_NOTE_ADDED": "Thêm ghi chú về khách hàng",
      "CLIENT_NOTE_EDITED": "Sửa ghi chú về khách hàng",
      "CLIENT_TAG_ADDED": "Gắn thẻ khách hàng",
      "CLIENT_TAG_REMOVED": "Bỏ thẻ khách hàng",
      "CLIENT_INFO_UPDATED": "Sửa thông tin khách hàng",
      "ORG_INFO_UPDATED": "Sửa thông tin tổ chức",
      "ORG_SETTINGS_UPDATED": "Đổi quy tắc học phí",
      "ORG_PREFERENCES_UPDATED": "Đổi tuỳ chọn hiển thị",
      "MEMBER_INVITED": "Mời thành viên",
      "MEMBER_ROLE_CHANGED": "Đổi vai trò thành viên",
      "MEMBER_REMOVED": "Gỡ thành viên",
      "MEMBER_PLACEHOLDER_CREATED": "Thêm giáo viên chưa có tài khoản",
      "MEMBER_CONVERTED": "Chuyển giáo viên thành tài khoản",
      "BANK_LINKED": "Liên kết ngân hàng",
      "BANK_UNLINKED": "Gỡ liên kết ngân hàng",
      "BRANCH_CREATED": "Tạo chi nhánh",
      "BRANCH_UPDATED": "Sửa chi nhánh",
      "BRANCH_ARCHIVED": "Lưu trữ chi nhánh",
      "BRANCH_UNARCHIVED": "Khôi phục chi nhánh",
      "BRANCH_SLOTS_ASSIGNED": "Gán lớp vào chi nhánh",
      "SUBSCRIPTION_UPGRADE_REQUESTED": "Yêu cầu nâng gói",
      "SUBSCRIPTION_RENEWAL_STOPPED": "Dừng tạo hoá đơn kỳ tới",
      "SUBSCRIPTION_RENEWAL_RESUMED": "Tiếp tục gia hạn gói",
      "SUBSCRIPTION_INVOICE_CANCELLED": "Huỷ hoá đơn gói",
      "INVOICE_UPDATED": "Sửa hoá đơn",
      "PAYMENT_RECORDED": "Ghi nhận thanh toán",
      "PAYMENT_LINKED": "Gán giao dịch vào hoá đơn",
      "PAYMENT_IGNORED": "Bỏ qua giao dịch chưa khớp",
      "PAYMENT_DELETED": "Xoá thanh toán",
      "INVOICE_DUE_DATE_BULK": "Đổi hạn thanh toán hàng loạt",
      "EXPENSE_CREATED": "Thêm khoản chi",
      "EXPENSE_UPDATED": "Sửa khoản chi",
      "EXPENSE_DELETED": "Xoá khoản chi",
      "PAYROLL_ADJUSTMENT_CREATED": "Thêm điều chỉnh lương",
      "PAYROLL_ADJUSTMENT_DELETED": "Xoá điều chỉnh lương",
      "STUDENT_CREATED": "Thêm học viên",
      "STUDENT_UPDATED": "Sửa thông tin học viên",
      "STUDENTS_IMPORTED": "Nhập học viên từ file",
      "CLIENT_CREATED": "Thêm khách hàng",
      "CLIENT_DELETED": "Xoá khách hàng",
      "CLIENT_NOTE_DELETED": "Xoá ghi chú về khách hàng",
      "SUBJECT_CREATED": "Tạo môn học",
      "SUBJECT_UPDATED": "Sửa môn học",
      "SUBJECT_DELETED": "Xoá môn học",
      "SCHEDULE_TEMPLATE_CREATED": "Tạo mẫu lịch học",
      "SCHEDULE_TEMPLATE_UPDATED": "Sửa mẫu lịch học",
      "SCHEDULE_TEMPLATE_DELETED": "Xoá mẫu lịch học",
      "SCHEDULE_TEMPLATE_ENTRIES_REPLACED": "Cập nhật nội dung mẫu lịch",
      "SLOT_CREATED": "Tạo lớp",
      "SLOT_UPDATED": "Sửa lớp",
      "SLOT_ARCHIVED": "Lưu trữ lớp",
      "SLOT_UNARCHIVED": "Khôi phục lớp",
      "SLOT_MEMBER_ADDED": "Thêm học viên vào lớp",
      "SLOT_MEMBER_REMOVED": "Rút học viên khỏi lớp",
      "CLASS_CREATED": "Tạo lớp",
      "CLASS_UPDATED": "Sửa lớp",
      "CLASS_ARCHIVED": "Lưu trữ lớp",
      "CLASS_UNARCHIVED": "Khôi phục lớp",
      "CLASS_MEMBERS_ADDED": "Thêm học viên vào lớp",
      "SESSION_CREATED": "Tạo buổi học",
      "SESSION_UPDATED": "Sửa buổi học",
      "SESSION_CANCELLED": "Huỷ buổi học",
      "SESSION_PARTICIPANT_ADDED": "Thêm học viên vào buổi",
      "SESSION_PARTICIPANT_REMOVED": "Bỏ học viên khỏi buổi",
      "SESSION_PARTICIPANT_MOVED": "Chuyển học viên sang buổi khác",
      "BANK_PRIMARY_CHANGED": "Đổi tài khoản nhận học phí"
    },
    "fields": {
      "invoiceDueDay": "Ngày hạn thanh toán mặc định",
      "invoiceMessageTemplate": "Mẫu tin nhắn học phí",
      "defaultChargeAbsent": "Mặc định tính buổi vắng không phép",
      "name": "Tên",
      "phone": "Số điện thoại",
      "email": "Email",
      "address": "Địa chỉ",
      "businessType": "Loại hình",
      "teamSize": "Quy mô",
      "preferredChannel": "Kênh liên lạc",
      "defaultCurrency": "Tiền tệ",
      "sellsExtras": "Bán phụ",
      "showTeacherAssignment": "Hiện giáo viên phụ trách",
      "absenceQuota": "Số buổi nghỉ có phép",
      "watermark": "Watermark",
      "dueDate": "Hạn thanh toán",
      "notes": "Ghi chú",
      "taxRate": "Thuế",
      "depositAmount": "Đặt cọc",
      "amount": "Số tiền",
      "category": "Hạng mục",
      "date": "Ngày",
      "description": "Mô tả",
      "nickname": "Tên gọi ở nhà",
      "gender": "Giới tính",
      "dateOfBirth": "Ngày sinh",
      "defaultRate": "Học phí mặc định mỗi buổi",
      "defaultMonthlyRate": "Học phí mặc định mỗi tháng",
      "dayOfWeek": "Thứ",
      "startTime": "Giờ bắt đầu",
      "startAt": "Thời điểm",
      "durationMin": "Thời lượng (phút)",
      "maxCapacity": "Sĩ số tối đa",
      "branchId": "Chi nhánh",
      "teachers": "Giáo viên",
      "teacherId": "Giáo viên",
      "note": "Ghi chú",
      "logoUrl": "Logo",
      "maxExcusedPerMonth": "Số buổi phép tối đa mỗi tháng",
      "showInvoiceWatermark": "Chữ mờ trên hoá đơn",
      "brandColor": "Màu thương hiệu",
      "classMode": "Tổ chức lớp"
    }
  }
}
